export const LOGIN_ERROR_CODE = {
  LOCK_MEMBER: 'LOCK_MEMBER',
  LOGIN_FAILED: 'LOGIN_FAILED'
} as const